import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const StationDropdownBoundTemplateWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "station-dropdown-bound-template-wrapper",
  },
)<{ $width: string }>`
  display: flex;
  align-items: center;
  width: 100%;
  width: ${props => props.$width};

  .inner-container {
    gap: 8px;
    display: flex;
    align-items: center;
    width: 100%;

    .add-button-container,
    .find-nearby-button-container {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
  }
`;
